import axios from 'axios';
let api_host = window.env.API_URL;
let ipify= window.env.IPIFY_URL;
let unleash_host=window.env.HUB_GATEWAY_UNLEASH_URL;
let headers =  {
    'Content-Type': 'application/json',
};

const urlHelper = {
    baseUrl: window.env.API_URL,
    version: 'v2',
    'generateOtp':'auth/generate-otp',
    'login':'auth/login?login_challenge=',
    'signup': 'auth/signup',
    'verified-identity': 'auth/login-verified-identity?login_challenge=',
    'verify-mapped-identity': 'auth/login-verify-mapped-identity?login_challenge=',
    getFullUrl: function (urlKey, login_challenge) {
      let url = `${this.baseUrl}/${this.version}/${this[urlKey]}`;
      if (login_challenge)   url += login_challenge
      return url
    }
  }
export default {

    getDefaultUrl (state = null){
        let url = api_host + '/hydra/start-oauth-flow-url';
        if(state){
            url = url + '?state='+state;
        }

        return axios.get(url, {headers: headers});
    },

    generateOtp(user, tokenType = null, accessToken = null) {
        if(tokenType && accessToken){
            headers.Authorization =  tokenType+ ' '+accessToken;
        }
        let userData = {};
        
        if(user.mobile){
            userData['username'] = user.mobile;
            userData['isdcode'] = user.isdcode;
        }
        if(user.email){
            userData['username'] = user.email;
        }

        let object = JSON.stringify(userData);
        
        const url = api_host + '/auth/generate-otp';
        return axios.post(url, object, {headers: headers});
    },


    getUserInfo(tokenType, accessToken) {

        let headers =  {
            'Content-Type': 'application/json',
            'Authorization': tokenType+ ' '+accessToken
        };

        const url = api_host + '/v1/users/me';
        return axios.get(url, {headers: headers});
    },

    loginUsingLtt(token, login_challenge){

        let userData = {};
        userData['token'] = token;
        userData['login_type'] = "ltt";

        let object = JSON.stringify(userData);

        const url = api_host + '/auth/login?login_challenge='+ login_challenge;
        return axios.post(url, object, {headers: headers});
    },

    logout(){

        const url = api_host + '/hydra/logout-url';
        return axios.get(url, {headers: headers});
    },

    getSocialLink (login_challenge){
        const url = api_host + '/auth/social-login?login_challenge='+ login_challenge;
        return axios.get(url, {headers: headers});
    },


    resetSession(refresh_token) {

        const url = api_host + '/hydra/refresh?refresh_token='+refresh_token;
        return axios.get(url, {headers: headers});

    },

    validateUser(user,isdCode,otp,request_id, tokenType, accessToken){

        let headers =  {
            'Content-Type': 'application/json',
            'Authorization': tokenType+ ' '+accessToken
        };

        let userData = {};

        if(user.mobile){
            userData['username'] = user.mobile;
            userData['isdcode'] = user.isdcode;
        }
        if(user.email){
            userData['username'] = user.email;
        }

        userData['otp'] = otp;
        userData['request_id'] = request_id;

        let object = JSON.stringify(userData);

        const url = api_host + '/v1/users/verify';
        return axios.post(url, object, {headers: headers});
    },

    registerUserName(payload){
        return this.sendPayload(payload,'signup');
    },

    async  getUnleaseValue(feature="accounts-recaptcha"){
        const myIP=await axios.get(`${ipify}`);
        const userId=myIP.data.ip;
        const res=  axios.get(`${unleash_host}`, {
            params: { userId, feature },
        },{headers});  
        return res.data;
    },
   
    generateOTP_v2(payload, tokenType = null, accessToken = null) {
        if(tokenType && accessToken){
            headers.Authorization =  tokenType+ ' '+accessToken;
        }
       return this.sendPayload(payload,'generateOtp');
    },

    
    sendPayload(payload, urlKey, login_challenge=null) {
        const url= urlHelper.getFullUrl(urlKey,login_challenge);
        return axios.post(url,payload, { headers });
    }

}

